/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
// MyCustomContent.jsx
import React, { useEffect, useState } from 'react';
import { DropDownListComponent, MultiSelectComponent, CheckBoxSelection, Inject } from '@syncfusion/ej2-react-dropdowns';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { SwitchComponent, ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { useStateContext } from '../contexts/ContextProvider';

function GroupContent({ props }) {
  if (!props) {
    return <p>No props</p>;
  }

  const fieldSettings = { text: 'name', value: '_id' };
  const invFieldSettings = { text: 'device', value: '_id' };
  const [selName, setName] = useState('');
  const [selGroupId, setGroupId] = useState('');
  const [reload, setReload] = useState(true);
  const [selectAllAssociates, setSelectAllAssociates] = useState(false);
  const [selectAllDevices, setSelectAllDevices] = useState(false);
  const [selectAllOrganizations, setSelectAllOrganizations] = useState(false);
  const usr = JSON.parse(localStorage.getItem('user'));
  const multilineAttributes = {
    rows: 4, // Sets the initial visible number of lines to 4
  };
  const { groups, setGroups, isDialogOpen, setIsDialogOpen } = useStateContext();

  const orgFieldSettings = { text: 'title', value: '_id' };
  const [associates, setAssociates] = useState([]);
  const [selectedAssociates, setSelectedAssociates] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [devices, setDevices] = useState([]);
  const [selectedOrganization, setOrganization] = useState('');
  const [btnTitle, setBtnTitle] = useState('Create');
  const [expanded, setImportExpanded] = useState('Create');
  let assocRef;
  let deviceRef;
  const { REACT_APP_API_ENDPOINT } = process.env;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/campaigngroupremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/campaigngroupupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  const handleExpanded = () => {
    setImportExpanded(!expanded);
  };
  const onFileUpload = (args) => {
    // add addition data as key-value pair.
    let found = false;
    for (let i = 0; i < props.organization.length; i += 1) {
      if (props.organization[i]._id === selectedOrganization) {
        found = true;
        break;
      }
    }
    if (!found) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selectedOrganization }, { name: usr.email }];
  };

  const completeUpload = (args) => {
    DialogUtility.alert(`Upload success ${args.fileData[0].status}`);
    setSelectedAssociates([]);
    setSelectedDevices([]);
    setReload(!reload);
    setIsDialogOpen(false);
  };

  const changeGroup = (e) => {
    for (let x = 0; x < groups.length; x += 1) {
      if (groups[x]._id === e.value) {
        if (e.value === 'na') {
          setOrganization('');
          setName('');
          setGroupId('');
          setSelectedAssociates([]);
          setSelectedDevices([]);
          setBtnTitle('Create');
          setSelectAllOrganizations(false);
          setSelectAllAssociates(false);
          setSelectAllDevices(false);
        } else {
          setGroupId(groups[x]._id);
          setName(groups[x].name);
          setSelectedDevices(groups[x].devices);
          setSelectedAssociates(groups[x].associates);
          setBtnTitle('Save');
          setOrganization(groups[x].organizationid);
          setSelectAllOrganizations(groups[x].hierarchy);
          setSelectAllAssociates(groups[x].futureAssociates);
          setSelectAllDevices(groups[x].futureDevices);
        }
      }
    }
  };
  const saveCampaignGroup = () => {
    const mygroups = groups;
    const group = {};
    group._id = selGroupId;
    group.name = selName;
    group.organizationid = selectedOrganization;
    group.devices = deviceRef.value;
    group.associates = assocRef.value;
    group.hierarchy = selectAllOrganizations;
    group.futureAssociates = selectAllAssociates;
    group.futureDevices = selectAllDevices;
    fetch(`${REACT_APP_API_ENDPOINT}/campaigngroup`, {
      method: btnTitle === 'Create' ? 'POST' : 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(group),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          mygroups.push(responseJson);
          setGroups(mygroups);
          setReload(!reload);
          DialogUtility.alert(`Campaign Group ${group.name} created!`);
          setIsDialogOpen(!isDialogOpen);
        } else if (responseJson && responseJson.response && responseJson.response === 'OK') {
          DialogUtility.alert(`Campaign Group ${group.name} saved!`);
          setIsDialogOpen(!isDialogOpen);
        } else {
          DialogUtility.alert(`Campaign Group ${group.name} error!`);
        }
      })
      .catch((error) => {
        DialogUtility.alert(`Campaign Group error ${error.message}!`);
      });
  };
  useEffect(() => {
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/campaigngroup?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
        // set state when the data received
      if (mydata && mydata.length > 0) {
        const mygroups = [];
        mygroups.push({ _id: 'na', name: 'Add New', associates: [], devices: [], organization: '' });
        mydata.forEach((element) => {
          mygroups.push(element);
        });
        setGroups(mygroups);
      } else {
        setGroups([]);
      }
    };
    dataFetch();
  }, [reload]);
  useEffect(() => {
    const dataFetch = async () => {
      if (selectedOrganization && selectedOrganization.length > 0) {
        usr.organizationid = selectedOrganization;
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/associates?${query}&specific=true`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json()
          .catch((err) => {
            console.error('Error parsing JSON:', err);
            return null;
          });
        // set state when the data received
        if (mydata && mydata.associates && mydata.associates.length > 0) {
          setAssociates(mydata.associates);
        } else {
          setAssociates([]);
        }
      }
    };
    dataFetch();
  }, [selectedOrganization]);
  useEffect(() => {
    const dataFetch = async () => {
      if (selectedOrganization && selectedOrganization.length > 0) {
        usr.organizationid = selectedOrganization;
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&specific=true`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json()
          .catch((err) => {
            console.error('Error parsing JSON:', err);
            return null;
          });
        // set state when the data received
        if (mydata && mydata.inventory && mydata.inventory.length > 0) {
          setDevices(mydata.inventory);
        } else {
          setDevices([]);
        }
      }
    };
    dataFetch();
  }, [selectedOrganization, reload]);
  return (
    <div>
      <AccordionComponent expanded={handleExpanded}>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
          <div className="e-input-group">
            <div className="mt-4"> Import </div>
          </div>

          <div className="">
            <div className="e-input-group">
              <DropDownListComponent id="ddlelement" width={300} cssClass="e-outline" dataSource={props.organization} fields={orgFieldSettings} floatLabelType="" placeholder="Select Organization" value={selectedOrganization} onChange={(v) => { setOrganization(v.value); }} />
              <div className="control" style={{ margin: '5px 0' }}>
                <UploaderComponent
                  id="fileupload"
                  type="file"
                  asyncSettings={path}
                  buttons={buttons}
                  multiple={false}
                  actionComplete={completeUpload}
                  autoUpload={false}
                  uploading={onFileUpload}
                  allowedExtensions=".csv"
                />
              </div>
            </div>
          </div>
        </div>
      </AccordionComponent>
      {expanded && (
      <div className="mt-2 e-input zackat-div"> {/* e-input-group */}
        <DropDownListComponent floatLabelType="Auto" className="e-field e-textlabel custom-checkbox-label" id="orgid" placeholder="Choose Existing Group" data-name="campaigngroup" fields={fieldSettings} dataSource={groups} onChange={changeGroup} />
        <TextBoxComponent multiline htmlAttributes={multilineAttributes} value={selName} title="group name" placeholder="Campaign Group Name" floatLabelType="Auto" onChange={(e) => { setName(e.value); }} />
        <DropDownListComponent floatLabelType="Auto" className="e-field e-textlabel custom-checkbox-label" id="orgid" required placeholder="Choose Organization" data-name="orgid" fields={orgFieldSettings} dataSource={props.organization} onChange={(e) => { setOrganization(e.value); }} value={selectedOrganization} />
        <div className="mt-2 e-input-group">
          <label htmlFor="hierarchy">Enable Hierarchy:</label>
          <SwitchComponent id="hierarchy" data-name="hierarchy" checked={selectAllOrganizations} cssClass="bar-color handle-color" change={(e) => { setSelectAllOrganizations(e.checked); }} />
        </div>
        <MultiSelectComponent
          id="Associates"
          ref={(scope) => assocRef = scope}
          popupWidth="300px"
          floatLabelType="Auto"
          allowResize
          required
          placeholder="Choose Associates"
          showSelectAll
          mode="CheckBox"
          data-name="associates"
          className="e-field"
          fields={fieldSettings}
          dataSource={associates}
          change={(e) => { if (e.value.length === associates.length) { setSelectAllAssociates(true); } }}
          value={props.associates || selectedAssociates}
        >
          <Inject services={[CheckBoxSelection]} />
        </MultiSelectComponent>
        <div className="mt-2 e-input-group">
          <label htmlFor="futureAssociates">Enable Future Associates:</label>
          <SwitchComponent data-name="futureAssociates" id="futureAssociates" checked={selectAllAssociates} cssClass="bar-color handle-color" change={(e) => { setSelectAllAssociates(e.checked); }} />
        </div>
        <MultiSelectComponent
          id="Devices"
          ref={(scope) => deviceRef = scope}
          popupWidth="300px"
          floatLabelType="Auto"
          allowResize
          required
          placeholder="Choose Devices"
          showSelectAll
          mode="CheckBox"
          data-name="devices"
          className="e-field"
          fields={invFieldSettings}
          dataSource={devices}
          change={(e) => { if (e.value.length === devices.length) { setSelectAllDevices(true); } }}
          value={props.devices || selectedDevices}
        >
          <Inject services={[CheckBoxSelection]} />
        </MultiSelectComponent>
        <div className="mt-2 e-input-group">
          <label htmlFor="showDevices">Enable Future Devices:</label>
          <SwitchComponent id="showDevices" data-name="futureDevices" checked={selectAllDevices} cssClass="bar-color handle-color" change={(e) => { setSelectAllDevices(e.checked); }} />
        </div>
        <div className="mb-10" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonComponent className="mb-10" cssClass="e-small" iconCss={btnTitle === 'Create' ? 'e-icons e-plus' : 'e-icons e-edit'} placeholder="Create" onClick={saveCampaignGroup}>{btnTitle}</ButtonComponent>
        </div>
      </div>
      )}
    </div>
  );
}

export default GroupContent;
